export const AS_DEV_USER = false;
const path = {
    // url: 'https://rebuildsl-api.idmrt.dev',
    url: 'https://rebuildingsrilanka.gov.lk/sathkara',
    basePath: 'api/v1'
};

const conf = {
    serverUrl: path.url,
    basePath: path.basePath,
    port: 80
};

export default conf
